import React from 'react';
import { motion } from 'framer-motion';
import { Leaf } from 'lucide-react';
export function FinalCTA() {
  return <section id="final-cta-section" className="w-full px-4 py-24 bg-sage text-ivory" data-id="element-54">
      <div className="max-w-4xl mx-auto text-center" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8 flex flex-col items-center" data-id="element-56">
          <Leaf className="w-8 h-8 text-ivory/50 mb-4" data-id="element-57" />

          <h2 className="text-4xl md:text-6xl font-serif leading-tight" data-id="element-58">
            Tu cuerpo lleva tiempo pidiéndote calma
          </h2>

          <p className="text-lg md:text-xl text-ivory/90 max-w-2xl mx-auto leading-relaxed" data-id="element-59">
            Inflamación silenciosa, cansancio, hinchazón, niebla mental… no
            tienes por qué seguir conviviendo con eso. Esta guía te da la ruta
            clara para empezar a sentirte distinta, paso a paso, con un plan
            real de 21 días.
          </p>

          <div className="pt-6 pb-2 flex flex-col items-center w-full" data-id="element-60">
            <p className="text-sm md:text-base text-cream/90 mb-4 flex items-center gap-2 font-medium" data-id="element-61">
              <span aria-hidden="true" data-id="element-62">⏰</span>
              Esta oferta del 75% OFF termina al cerrar esta semana
            </p>
            <div className="flex items-end justify-center gap-4 mb-8 flex-wrap" data-id="element-63">
              <span className="text-2xl text-ivory/50 line-through decoration-1" data-id="element-64">
                $39.99
              </span>
              <span className="text-6xl font-serif font-bold" data-id="element-65">
                $9.99{' '}
                <span className="text-2xl font-sans font-normal" data-id="element-66">USD</span>
              </span>
            </div>

            <a href="https://www.epikkastore.com/cart/45160332132375:1" className="inline-block text-center w-full md:w-auto bg-ivory hover:bg-cream text-clay text-xl font-bold py-5 px-12 rounded-full transition-all shadow-xl hover:shadow-2xl transform hover:-translate-y-0.5 duration-200" data-id="element-67">
              Quiero empezar mi cambio hoy — $9.99
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-ivory/85 font-medium" data-id="element-68">
            <span data-id="element-69">Acceso digital inmediato</span>
            <span className="hidden sm:inline" data-id="element-70">·</span>
            <span data-id="element-71">Devolución 7 días</span>
            <span className="hidden sm:inline" data-id="element-72">·</span>
            <span data-id="element-73">75% OFF solo por esta semana</span>
          </div>

          <p className="text-base md:text-lg font-serif italic text-cream/90 pt-4 max-w-xl" data-id="element-74">
            Mañana puede ser otro "algún día". O puede ser tu día 1.
          </p>
        </motion.div>
      </div>
    </section>;
}